
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Puneoutstationcabs() {



    const cardData =
    {
        keyword: ' Pune Outstation Cabs',
        heading: 'Mauli Cabs: Pune Outstation Cabs',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune outstation cabs, making your long-distance travel stress-free and enjoyable. Whether you are planning a weekend getaway, a family trip, or a business journey, we provide a wide selection of vehicles including sedans, SUVs, and premium cars to suit your travel requirements. With professional drivers, transparent pricing, no hidden charges, and a strong focus on customer satisfaction, Mauli Cabs guarantees a smooth and hassle-free outstation cab service from Pune to your desired destination.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada is a historical fortification and the seat of the Peshwa rulers of the Maratha Empire. It is famous for its architectural grandeur and rich history, with beautiful gardens and stunning views of the surrounding area."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Aga Khan Palace is an elegant historical building, known for its beautiful Italian arches and serene surroundings. The palace has significant historical importance as it was used as a prison for freedom fighters during the British colonial era."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Sinhagad Fort is a popular historic fort located on the outskirts of Pune, offering panoramic views of the surrounding hills and valleys. It is known for its scenic trekking routes and its importance in Maratha history."
    },
    {
        "title": "Osho Ashram",
        "description": "The Osho Ashram, also known as the Osho International Meditation Resort, is a peaceful sanctuary located in Koregaon Park. It offers a variety of meditation programs and wellness treatments, attracting spiritual seekers from around the world."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "The Pune Okayama Friendship Garden, also known as the Pu La Deshpande Garden, is a Japanese-style garden located in the heart of the city. It features lush greenery, serene ponds, and beautiful walking paths, perfect for a peaceful stroll."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva. Located in the city center, this historical monument offers a glimpse into Pune's rich religious and architectural heritage."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Raja Dinkar Kelkar Museum is a fascinating museum showcasing a vast collection of artifacts, including sculptures, paintings, and textiles, reflecting the rich cultural heritage of India."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam is located on the outskirts of Pune and is a popular spot for picnics and relaxation. The dam offers scenic views of the water and surrounding hills, making it an ideal place for a peaceful day out."
    },
    {
        "title": "Fergusson College",
        "description": "Fergusson College is one of the oldest and most prestigious educational institutions in India. The college campus is known for its beautiful colonial architecture, serene environment, and historical significance."
    },
    {
        "title": "Bund Garden",
        "description": "Bund Garden is a well-maintained park located along the Mula-Mutha River. It is a popular spot for jogging, picnics, and boat rides, offering beautiful views of the river and surrounding greenery."
    }
],

"services": [
    {
      "name": "Pune Outstation Cab Services",
      "description": "Explore nearby cities and destinations with our reliable outstation cab services from Pune. Whether you’re traveling for leisure or business, our comfortable vehicles and experienced drivers ensure a smooth and hassle-free journey to your desired destination."
    },
    {
      "name": "Pune Outstation Taxi Booking",
      "description": "Booking a taxi for your outstation trip from Pune is quick and easy. With online booking, you can secure a cab of your choice with instant confirmation and plan your journey with confidence."
    },
    {
      "name": "Pune Outstation Car Rental",
      "description": "Rent a car for your outstation journey from Pune. Whether you prefer a self-drive car or a chauffeur-driven vehicle, we offer a range of vehicles to suit your travel needs and provide a comfortable and flexible travel experience."
    },
    {
      "name": "Pune Outstation Chauffeur-Driven Cabs",
      "description": "For a relaxing journey, choose our chauffeur-driven cabs for your outstation trips from Pune. Our experienced drivers ensure a smooth and safe trip, allowing you to sit back and enjoy the scenic drive."
    },
    {
      "name": "Pune Outstation One-Way Taxi",
      "description": "Our one-way taxi service is perfect for those who need to travel to another city without the need for a return trip. Book your one-way cab for a direct journey from Pune to your outstation destination."
    },
    {
      "name": "Pune Outstation Round Trip Cabs",
      "description": "Planning a round trip for your outstation travel from Pune? Our round-trip cab services offer the convenience of a round journey with a professional driver, ensuring your comfort throughout the trip."
    },
    {
      "name": "Pune Outstation Luxury Taxi",
      "description": "Travel in style with our luxury taxi services for outstation trips. Choose from premium vehicles like Mercedes, BMW, and Audi for a high-end travel experience from Pune to your outstation destination."
    },
    {
      "name": "Pune Outstation Self-Drive Car Rental",
      "description": "If you prefer driving yourself, opt for our self-drive car rental services. We offer a variety of vehicles for your outstation trip, ensuring flexibility and convenience for your journey from Pune."
    },
    {
      "name": "Pune Outstation Travel Packages",
      "description": "Our outstation travel packages are designed to provide a complete experience. From sightseeing tours to local attractions, we offer curated packages that fit various budgets, making your outstation travel from Pune enjoyable and affordable."
    },
    {
      "name": "Pune Outstation Private Car Hire",
      "description": "For those who seek privacy and comfort, our private car hire services are an ideal choice for outstation travel. Hire a private car for a custom itinerary and explore your destination at your own pace."
    },
    {
      "name": "Pune Outstation Cabs",
      "description": "Book a reliable and comfortable outstation cab service from Pune to various cities. Our outstation cabs are equipped with modern amenities to make your journey safe and pleasant."
    },
    {
      "name": "Outstation Taxi Service Pune",
      "description": "Our outstation taxi service from Pune offers hassle-free travel to a variety of destinations. Whether you're looking for a short weekend getaway or a long-distance trip, our taxis ensure comfort and reliability."
    },
    {
      "name": "One Way Cab Pune",
      "description": "Looking for a one-way cab from Pune to your outstation destination? Our one-way taxi service provides you with direct, affordable, and comfortable rides to your destination without worrying about the return journey."
    },
    {
      "name": "Best Outstation Cab Service in Pune",
      "description": "Choose the best outstation cab service in Pune with top-rated vehicles, experienced drivers, and transparent pricing. We provide the best quality service for your outstation trips, making your journey stress-free."
    },
    {
      "name": "Outstation Cab Service in Pune",
      "description": "Our outstation cab services in Pune provide safe and reliable transportation to nearby cities. Whether you're traveling for work or leisure, our service is tailored to meet your travel needs."
    },
    {
      "name": "Outstation Car Rental Pune",
      "description": "Rent a car for your outstation journey from Pune. We offer various car rental options, including self-drive and chauffeur-driven services, ensuring flexibility and comfort during your trip."
    },
    {
      "name": "Taxi in Pune for Outstation",
      "description": "Book a taxi in Pune for your outstation trip and enjoy a seamless travel experience. Our outstation taxis are available for both short and long trips, providing affordable and comfortable travel."
    },
    {
      "name": "Taxi Service in Pune for Outstation",
      "description": "Our taxi service in Pune for outstation journeys offers comfort, reliability, and punctuality. Choose from a wide range of vehicles for your next outstation trip and enjoy the best rates and service."
    },
    {
      "name": "Book Outstation Cabs Pune",
      "description": "Booking an outstation cab from Pune is easy with our online platform. Get instant confirmation and enjoy a smooth ride to your destination with our reliable and professional cab service."
    },
    {
      "name": "Cab Booking in Pune for Outstation",
      "description": "Book a cab for your outstation travel from Pune. We offer flexible booking options, competitive pricing, and a variety of vehicle choices to make your journey comfortable and affordable."
    },
    {
      "name": "Outstation Taxi in Pune",
      "description": "Our outstation taxi services from Pune are designed for comfort, safety, and reliability. Whether you're planning a weekend getaway or a longer trip, we ensure that your outstation travel is as convenient as possible."
    },
    {
      "name": "Outstation Taxi Service in Pune",
      "description": "Looking for outstation taxi services in Pune? Our professional drivers, well-maintained vehicles, and affordable fares make us the preferred choice for your next outstation trip."
    },
    {
      "name": "Pune Airport to Kolhapur Cab",
      "description": "Travel from Pune Airport to Kolhapur with ease. Our cab services ensure a comfortable, direct ride to Kolhapur, offering flexible pick-up and drop-off options to suit your schedule."
    },
    {
      "name": "Pune Car Rental Outstation",
      "description": "Rent a car from Pune for your outstation trips. Our car rental services offer you flexibility and comfort, with a variety of vehicles to choose from for your journey."
    },
    {
      "name": "Pune to Gokarna Cab",
      "description": "Travel from Pune to Gokarna with our affordable and comfortable cab services. Whether you're visiting for a peaceful beach vacation or spiritual retreat, we ensure a smooth and enjoyable ride."
    },
    {
      "name": "Pune to Outstation Taxi",
      "description": "Book an outstation taxi from Pune to your favorite destination. Our professional drivers and well-maintained vehicles ensure that your journey is both comfortable and safe."
    }
  ],
  "tableData": [
    ["Pune Outstation Cab Services", "Pune Outstation Taxi Booking"],
    ["Pune Outstation Car Rental", "Pune Outstation Chauffeur-Driven Cabs"],
    ["Pune Outstation One-Way Taxi", "Pune Outstation Round Trip Cabs"],
    ["Pune Outstation Luxury Taxi", "Pune Outstation Self-Drive Car Rental"],
    ["Pune Outstation Travel Packages", "Pune Outstation Private Car Hire"],
    ["Pune Outstation Cabs", "Outstation Taxi Service Pune"],
    ["One Way Cab Pune", "Best Outstation Cab Service in Pune"],
    ["Outstation Cab Service in Pune", "Outstation Car Rental Pune"],
    ["Taxi in Pune for Outstation", "Taxi Service in Pune for Outstation"],
    ["Book Outstation Cabs Pune", "Cab Booking in Pune for Outstation"],
    ["Outstation Taxi in Pune", "Outstation Taxi Service in Pune"],
    ["Pune Airport to Kolhapur Cab", "Pune Car Rental Outstation"],
    ["Pune to Gokarna Cab", "Pune to Outstation Taxi"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for all your outstation travel from Pune. Our professional drivers ensure prompt pickups and drop-offs, making your journey comfortable and hassle-free, whether you’re traveling for business or leisure."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your outstation trips from Pune, we provide a wide range of vehicles to choose from. From budget-friendly sedans to luxurious SUVs, all our vehicles are well-maintained, air-conditioned, and equipped with ample space for a comfortable and relaxed journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and local conditions for outstation travel. They ensure a smooth, safe, and timely journey, allowing you to enjoy the scenic beauty of the route without any worries about navigation or safety."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive and transparent pricing for your outstation trips from Pune. We provide clear, upfront pricing with no hidden charges, so you can enjoy a great travel experience at an affordable rate."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure that your outstation journey is both secure and comfortable."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for all your outstation travel needs from Pune. Whether you're planning a late-night departure or an early-morning start, our customer service team is ready to assist with booking your ride at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your outstation cab with Mauli Cabs is quick and easy. You can make your reservation online through our website or mobile app, or contact our customer service team for personalized assistance, ensuring a seamless and hassle-free booking process."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your outstation journeys from Pune. Whether you're traveling for a weekend getaway, a family trip, or a business assignment, we can tailor the trip to meet your specific requirements, ensuring a smooth and memorable experience."
    }
]


























    }


    const faqData = [
        {
            question: 'How do I book an outstation cab from Pune with Mauli Cabs?',
            answer: 'Booking an outstation cab from Pune with Mauli Cabs is simple! You can book directly through our website or mobile app by entering your pickup location as Pune and your destination. Select the type of vehicle you prefer, confirm the booking, and you’re ready to go. Alternatively, you can contact our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for outstation trips from Pune?',
            answer: 'Mauli Cabs offers a variety of vehicles for your outstation trips from Pune, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can choose a vehicle based on your preferences for space, comfort, and budget.',
        },
        {
            question: 'Is the fare for an outstation trip from Pune fixed?',
            answer: 'Yes, the fare for outstation trips from Pune is fixed and transparent. The fare includes all charges such as tolls, taxes, driver fees, and other applicable charges. You will know the total fare upfront before booking, with no hidden costs.',
        },
        {
            question: 'Can I book a round trip for my outstation journey from Pune?',
            answer: 'Yes, you can easily book a round trip for your outstation journey. Provide the return details during booking, and we will ensure that your return trip is as smooth and comfortable as the onward journey.',
        },
        {
            question: 'How long does an outstation journey from Pune typically take?',
            answer: 'The time for outstation trips depends on the destination. For example, trips to nearby locations like Lonavala or Shirdi may take 1-2 hours, while longer trips like Pune to Mumbai or Pune to Goa may take 3-7 hours. You can get an estimated travel time when booking your cab.',
        },
        {
            question: 'Are the drivers experienced for outstation trips from Pune?',
            answer: 'Yes, all Mauli Cabs drivers are highly professional, experienced, and familiar with long-distance travel routes. They ensure a safe and smooth journey while prioritizing your comfort and punctuality.',
        },
        {
            question: 'Can I make stops during my outstation journey from Pune?',
            answer: 'Yes, you can make stops along the way for meals, refreshments, or sightseeing. Our drivers are flexible and will accommodate your requests to make the journey more comfortable and enjoyable.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained for outstation trips?',
            answer: 'Yes, all our cabs are air-conditioned and regularly maintained to ensure a comfortable and smooth ride. We ensure cleanliness and comfort, making your long journey enjoyable.',
        },
        {
            question: 'Can I cancel or modify my booking for an outstation trip from Pune?',
            answer: 'Yes, you can easily cancel or modify your booking for an outstation trip from Pune. We offer flexible cancellation and modification policies via our website or app, and our customer support team is always ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my outstation trip from Pune?',
            answer: 'Mauli Cabs offers affordable, fixed fares with no hidden charges, a variety of well-maintained vehicles, professional drivers, and a commitment to customer satisfaction. Whether you’re traveling for business, leisure, or a long road trip, we ensure a safe, comfortable, and hassle-free experience.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sandeep Mehta",
            position: "Business Traveler",
            text: "I traveled with Mauli Cabs for an outstation trip from Pune to Mumbai, and I had a great experience. The driver was professional, the vehicle was clean and well-maintained, and the journey was smooth. I would definitely use Mauli Cabs again for my future trips.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Priya Sharma",
            position: "Leisure Traveler",
            text: "Our family took a long outstation trip with Mauli Cabs from Pune to Goa, and it was an amazing experience. The car was spacious, air-conditioned, and very comfortable. The driver was friendly and ensured we had a great time. Highly recommended!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
  


    return (
        <div>
            <GTag/>

<Helmet>
    <title>Pune Outstation Cabs | Book Outstation Taxi & Car Rentals | Mauli Cabs</title>
    <meta
      name="description"
      content="Explore affordable and convenient Pune Outstation cab services for one-way, round-trip, and luxury taxis. Book outstation taxis from Pune to destinations like Kolhapur, Gokarna, Mahabaleshwar, and more. Get instant quotes for self-drive rentals and chauffeur-driven cabs."
    />
    <meta
      name="keywords"
      content="Pune Outstation Cab Services, Pune Outstation Taxi Booking, Outstation Car Rental Pune, Outstation Chauffeur-Driven Cabs, Pune Outstation Taxi, Pune to Kolhapur, Pune to Gokarna, Pune to Mahabaleshwar, Pune Airport Outstation Taxi, One-Way Outstation Cabs Pune, Round Trip Cabs Pune, Outstation Travel Packages, Self-Drive Car Rentals Pune"
    />
  </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/50.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Puneoutstationcabs;